<template>
	<div class="bottomBarBox">
		<div class="toScalar" :class="bottom==1?'active':''" @click="goceping()">
			<p class="icon">&#xe698;</p>
			<p class="tabDesc">测评列表</p>
		</div>
		<div class="toMy" :class="bottom==2?'active':''" @click="gomy()">
			<p class="icon">&#xe616;</p>
			<p class="tabDesc">我的</p>
		</div>
	</div>
</template>

<script>
	export default {
		props:{
			'bottom':[Number,String]
		},
		created:function(){
		},
		methods:{
			goceping:function(){
				this.$router.push({name:'scalarlist'});
			},
			gomy:function(){
				this.$router.push({name:'userinfo'});
			}
		}
	}
</script>

<style scoped>
	.bottomBarBox{
		position: fixed;
		bottom: 0;
		width: 100%;
		height: 1rem;
		display: flex;
		justify-content: space-around;
		background: #F0F0F0;
	}
	.toScalar,.toMy{
		width: 1.5rem;
		height: 100%;
	}
	.toScalar.active p,.toMy.active p{
		color: #26a2ff;
	}
	.icon{
		padding-top: 0.14rem;
		text-align: center;
		font-size: 0.484rem;
		line-height: 0.48rem;
		color: #666;
	}
	.tabDesc{
		line-height: 0.28rem;
		font-size: 0.24rem;
		color: #666;
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/components/bottomBar.vue